import styled from 'styled-components'
// @ts-expect-error // TODO
import BadgeWithPercentage from '../../assets/badge-with-percentage.svg?react'

export const CampaignBox = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.palette.secondary.light};
`

export const CampaignIcon = styled(BadgeWithPercentage)`
  width: 50px;
  height: 50px;
  margin: 30px;
`
